import { useEffect, useState } from 'react';
import { apiFetch } from '../config/api';
import StatTile, { StatSection } from './StatTile';
import AppVersionStats from './AppVersionStats';

// Aggregate counts across every school — super admin only (matches the
// backend's requireStaffAccount + is_super_admin gate on the endpoint).
export default function PlatformStatsOverview({ token }) {
  const [stats, setStats] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiFetch('/platform-stats/overview', {}, token)
      .then((res) => {
        if (!cancelled) setStats(res.data);
      })
      .catch((err) => {
        // A school-level admin hitting this (403) just doesn't see the section
        // rather than showing an error banner they can't act on.
        if (!cancelled && err.status !== 403) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (loading || !stats) {
    return error ? <div className="sa-error">{error}</div> : null;
  }

  const tile = (label, key) => (
    <StatTile key={key} label={label} value={stats[key] ?? null} />
  );

  return (
    <div style={{ marginBottom: 24 }}>
      <StatSection title="Schools">
        {tile('Total Schools', 'total_schools')}
        {tile('Active Schools', 'active_schools')}
        {tile('Trial Schools', 'trial_schools')}
        {tile('Paid Schools', 'paid_schools')}
      </StatSection>

      <StatSection title="Infrastructure">
        {tile('Total Campuses', 'total_campuses')}
        {tile('Total Zones', 'total_zones')}
      </StatSection>

      <StatSection title="Users">
        {tile('Total Parents', 'total_parents')}
        {tile('Total Students', 'total_students')}
        {tile('Total Staff', 'total_staff')}
        {tile('Total Admins', 'total_admins')}
      </StatSection>

      <AppVersionStats token={token} />
    </div>
  );
}
